export default __webpack_public_path__ + "static/media/toggle.441d0930.svg";